export default "__VITE_ASSET__c8dfa68c__"